<template>
<div class="chapter">
<div class="inner_page">
<p class="colophon"><span>Europa Editions<br/>
  214 West 29th St.<br/>
  New York NY 10001<br/>
  info@europaeditions.com<br/>
  www.europaeditions.com<br/>
<br/>
  This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously.<br/>
<br/>
  Copyright © Éditions Albin Michel, Paris 2017<br/>
  First publication 2018 by Europa Editions<br/>
<br/>
  Translation by Alison Anderson<br/>
  Original Title: <i>Frappe-toi le cœr<br/></i>Translation copyright © 2018 by Europa Editions<br/>
<br/>
  All rights reserved, including the right of reproduction in whole or in part in any form.<br/>
<br/>
  Cover Art by Emanuele Ragnisco<br/>
  www.mekkanografici.com<br/>
  Cover photo: pxhere<br/>
<br/>
  ISBN 9781609454869 <br/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Colophon.vue?1803ecb2